var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.clientId)?_c('div',{staticClass:"client-projects"},[_c('ClientProjectsTableWrapper',{attrs:{"clientId":_vm.clientId,"isReadOnly":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }